module.exports = __webpack_public_path__ + "img/background3.cc431e65.jpg";